/**
 * OMR Timing Marks Component
 * Renders vertical marks on left and right margins to help with horizontal synchronization
 * Used by OpenCV to slice the image into question rows
 */

import React from 'react';
import { getTimingMarkPositions } from '../../utils/omr/geometryCalc';
import {
  TIMING_MARK_WIDTH_MM,
  TIMING_MARK_HEIGHT_MM,
  QUESTIONS_START_Y_MM,
} from '../../utils/omr/constants';

const OMRTimingMarks = ({ numberOfQuestions }) => {
  const positions = getTimingMarkPositions(QUESTIONS_START_Y_MM, numberOfQuestions);

  const renderMarks = (markPositions) =>
    markPositions.map((pos, index) => (
      <div
        key={`timing-${index}`}
        style={{
          position: 'absolute',
          left: `${pos.x}mm`,
          top: `${pos.y}mm`,
          width: `${TIMING_MARK_WIDTH_MM}mm`,
          height: `${TIMING_MARK_HEIGHT_MM}mm`,
          backgroundColor: '#000000',
          border: 'none',
        }}
        className="omr-timing-mark"
        data-testid={`timing-mark-${index}`}
      />
    ));

  return (
    <>
      {renderMarks(positions.left)}
      {renderMarks(positions.right)}
    </>
  );
};

export default OMRTimingMarks;
